import React, { useMemo } from 'react'
import { rangeTypes } from '@dataplace.ai/constants'
import styled, { css } from 'styled-components'
import { catchmentIconsMap } from '../constants'

export const Wrapper = styled.div(({ theme: { typography } }) => css`
    font-size: ${typography.tiny.pt_11_medium.fontSize};
    font-weight: ${typography.tiny.pt_11_medium.fontWeight};
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.4rem;
    white-space: nowrap;
  `)

interface UseGetCatchmentInfoComponentProps {
  mode: (typeof rangeTypes)[keyof typeof rangeTypes]
  length: number
}

function CatchmentInfoComponent({
  mode, length,
}: UseGetCatchmentInfoComponentProps): JSX.Element {
  const catchmentText = useMemo(() => {
    let suffix
    let val = length
    if (mode === 'line') {
      if (length >= 1000) {
        suffix = 'km'
        val /= 1000
      } else {
        suffix = 'm'
      }
    } else {
      suffix = 'min'
    }
    return `${val} ${suffix}`
  }, [mode, length])

  return (
    <Wrapper>
      {catchmentIconsMap[mode]}
      {catchmentText}
    </Wrapper>
  )
}

export default CatchmentInfoComponent
